import { section } from "@/neon";
import { listen, qs } from "@fluorescent/dom";
import { animateQuote } from "@/lib/animation";

const slideshowOpts = {
  prevNextButtons: false,
  adaptiveHeight: false,
  pauseAutoPlayOnHover: false,
  wrapAround: true,
  pageDots: false,
  cellAlign: "center",
  draggable: false,
  fade: true,
};

section("quote", {
  listeners: [],

  onLoad() {
    import(flu.chunks.flickity).then(({ Flickity }) => {
      const { timer } = this.container.dataset;
      slideshowOpts.autoPlay = parseInt(timer);

      const quoteContainer = qs(".quote__container", this.container);

      this.slideshow = new Flickity(quoteContainer, slideshowOpts);

      this._initNavigation();
      this.animateQuote = animateQuote(this.container);
    });
  },

  _initNavigation() {
    const navNextButton = qs(".carousel__next-button", this.container);
    const navPrevButton = qs(".carousel__previous-button", this.container);

    this.listeners.push(
      listen(navPrevButton, "click", () => this.slideshow.previous())
    );
    this.listeners.push(
      listen(navNextButton, "click", () => this.slideshow.next())
    );
  },

  onBlockSelect({ target: slide }) {
    this.slideshow.select(slide.dataset.index);
    this.slideshow.pausePlayer();
  },

  onBlockDeselect() {
    this.slideshow.unpausePlayer();
  },

  onUnload() {
    this.slideshow.destroy();
    this.listeners.forEach(unsub => unsub());
    this.animateQuote?.destroy();
  },
});
